import classNames from "classnames";
import React, { ReactNode } from "react";

type SetupCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
};

export const SetupCard: React.FC<SetupCardProps> = ({
  icon,
  title,
  description,
  actionLabel = "+ Set up",
  disabled,
  className,
  onClick,
}) => {
  return (
    <button
      type={"button"}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        "flex w-full items-center gap-3 rounded-[11px] border-[1.5px] border-dashed border-[#C4B5FD]",
        "bg-[#FBFAFF] px-4 py-[14px] text-left transition-colors hover:bg-[#F4F0FF]",
        "disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}>
      <span
        className={
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-[9px] bg-[#F0EDFF] text-[#6B4EFF]"
        }>
        {icon}
      </span>

      <span className={"min-w-0 flex-1"}>
        <span
          className={
            "block font-Manrope text-[13.5px] font-bold leading-5 text-[#293B5A]"
          }>
          {title}
        </span>
        <span
          className={
            "mt-0.5 block font-Manrope text-[12.5px] leading-5 text-[#9097A8]"
          }>
          {description}
        </span>
      </span>

      <span
        className={
          "shrink-0 whitespace-nowrap font-Manrope text-[13px] font-bold text-[#6B4EFF]"
        }>
        {actionLabel}
      </span>
    </button>
  );
};
